import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Seo from '../components/ui/Seo';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Experience from '../components/sections/Experience';
import FeaturedProjects from '../components/sections/projects/FeaturedProjects';
import Skills from '../components/sections/Skills';
import Education from '../components/sections/Education';
import Certifications from '../components/sections/Certifications';
import Projects from '../components/sections/projects/Projects';
import Contact from '../components/sections/Contact';
import { profile } from '../data/profile';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const el = document.querySelector(location.hash);
    if (el) {
      // wait a tick for layout to settle after route change
      requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  }, [location.hash]);

  return (
    <main>
      <Seo
        title={`${profile.name} | AI Engineer in Pune`}
        description={`${profile.name} — ${profile.title}. ${profile.bio[0]}`}
        path="/"
      />
      <Hero />
      <About />
      <Experience />
      <FeaturedProjects />
      <Skills />
      <Education />
      <Certifications />
      <Projects />
      <Contact />
    </main>
  );
};

export default Home;
